import React, {memo} from "react";
import {formatShortenNumber} from "../utils/format";
import {useWordPressContents} from "../hook/useWordPressContents";
import {useQueryStateTopContentIds} from "../hook/useQuery";
import {useTranslation} from "../hook/useTranslation";

const TopPostsList = ({numberPosts, from, to})=>{

	const i18n = useTranslation("base")

	const list = useQueryStateTopContentIds("wpDashboardWidget",{
		numberOfItems: numberPosts,
		from, to
	})
	const contents = useWordPressContents();

	if(list.length < 1){
		return <p>No posts</p>;
	}

	return <ul className="ocdb-list">
		{list.map(({content_id, hits}) => {
			const {
				ID = content_id,
				title = content_id,
				url = "#"
			} = contents[content_id] || {}
			return (
				<li className="ocdb-list-item" key={ID}>
					<span className="ocdb-list-item-title"><a href={url}>{title}</a></span>
					<br/>
					<span className="ocdb-list-item-count">{formatShortenNumber(hits)} {i18n.hits}</span>
				</li>
			)
		})}
	</ul>
}
export default memo( TopPostsList );